import { Component, input } from '@angular/core';
import { AccordionComponent, AccordionElementComponent } from "@husbanken/designsystem-angular-core";
import { Tilskudd as TilskuddModel } from "../../../../models/tilskudd.model";

@Component({
  selector: "bko-tilskudd",
  imports: [AccordionComponent, AccordionElementComponent],
  templateUrl: "./tilskudd.html",
  styleUrl: "./tilskudd.scss",
})
export class Tilskudd {
  tilskudd = input<TilskuddModel[]>([]);
}
